/*
 * @Description: axios（ajax）请求方法文件
 * @Author: 段生华
 * @Date: 2019-05-06 11:24:29
 * @LastEditTime: 2021-05-06 14:58:02
 * @LastEditors: zhao - 🍉
 */

import {message, Modal} from 'antd';
import axios from 'axios';
import qs from 'qs';
import * as configs from './config';
import { handleExportParams } from '../utils';
import { HashRouter } from "react-router-dom";
import React from "react";
const router = new HashRouter();
let login_invalid = false; //登录失效

/**
 * @description: axios默认配置
 */
axios.defaults.withCredentials = true;

axios.interceptors.request.use(
    config => {
        //如果是登录、注册、验证码的接口，则不添加头部的商户/平台id
        if (!/(login|resetPassword|sendVerifyCode)/.test(config.url)) {
            let exportParams = handleExportParams();
            if (Object.keys(exportParams).length) {
                Object.assign(config.headers, exportParams);
            } else {
                if (window.location.href.indexOf('manage.shouyuhome.com') > -1) {
                    window.location.href = '/#/login';
                }
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code === 0)
            return response.data.data
        else if (response.data.code)
            return Promise.reject({ code: response.data.code, message: response.data.message, data: response.data.data });
        else
            return response.data
    },
    error => {
        if (error.response) {
            if (error.response.status === 401 && login_invalid === false) {
                login_invalid = true;
                message.error('登录已失效', 1).then(() => {
                    if (handleExportParams().employeeId) {
                        router.history.push('/login');
                    } else {
                        router.history.push('/merchantLogin');
                    }
                });
            }
            return Promise.reject({ code: error.response.code, message: typeof error.response.data === 'object' ? error.response.data.message : error.response.code });
        }
        return Promise.reject(error);
    }
);

/**
 * @description: 公用get请求
 * @param {url: string}   接口地址
 * @param {data: json}    接口参数
 * @param {msg: string}   接口错误提示
 * @param {headers: json} 接口请求头
 * @return: {axios: promise}
 */
export const get = function ({ url, data }) {
    return axios.get(url, data)
}
export const post = function ({ url, data, headers }) {
    return axios.post(url, data, headers)
}
/**
 * form表单方式
 */
export const postFrom = function ({ url, data, headers = {} }) {
    headers['Content-Type'] = 'application/x-www-form-urlencoded';
    data = qs.stringify(data);
    return axios.post(url, data, headers)
}
/**
 * 上传接口
 */
let uploadLoading = {};
export let uploadEnclosure = function ({ action = configs.API_upload_upload_file,headers = {}, accept = "image/*", tableName, attachType = 1, success, rowId = '', showUploadList=false, data={} }) {
    let exportParams = handleExportParams();
    if (Object.keys(exportParams).length) {
        Object.assign(headers, exportParams);
    }
    return {
        action,
        accept,
        showUploadList,
        headers,
        data: { rowId, tableName, attachType, ...data },
        beforeUpload: (file) => {
            uploadLoading[file.uid] = message.loading(`${file.name}上传中...`, 0);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                setTimeout(uploadLoading[info.file.uid], 0);
                delete uploadLoading[info.file.uid];
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件上传成功`);
                    success && success(info.file.name, res.data);
                } else {
                    message.error(res.message || `${info.file.name}文件上传失败`);
                }
            } else if (info.file.status === 'error') {
                setTimeout(uploadLoading[info.file.uid], 0);
                delete uploadLoading[info.file.uid];
                if (info.file.error.status === 401) {
                    message.error('登录已失效', 1).then(() => {
                        if (headers.employeeId) {
                            router.history.push('/login');
                        } else {
                            router.history.push('/merchantLogin');
                        }
                    })
                } else {
                    message.error(`${info.file.name}文件上传失败`);
                }
            }
        },
    }
}

export let uploadNewEnclosure = function ({ action = configs.API_upload_upload_file,headers = {}, accept = "image/*", tableName, attachType = 1, success, rowId = '', showUploadList=false, data={} }) {
    let exportParams = handleExportParams();
    if (Object.keys(exportParams).length) {
        Object.assign(headers, exportParams);
    }
    return {
        action,
        accept,
        showUploadList,
        headers,
        data: { rowId, tableName, attachType, ...data },
        beforeUpload: (file) => {
            message.loading(`${file.name}上传中...`);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件导入成功`);
                    if(res.data){
                        success && success(info.file.name, res.data);
                        // this.setState({showBillImportModal:true})
                        // this.handleGetBillImportLog(res.data)
                    }
                } else {
                    if(Array.isArray(res.data)){
                        Modal.error({
                            className:'importModal',
                            title: res.message || `${info.file.name}文件导入失败`,
                            content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                        });
                    }else{
                        message.error(res.message || `${info.file.name}文件导入失败`);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name}文件上传失败`);
            }
        },
    }
}


export let uploadNew1Enclosure = function ({ action = configs.API_upload_upload_file,headers = {}, accept = "image/*", tableName, attachType = 1, success, rowId = '', showUploadList=false, data={} }) {
    let exportParams = handleExportParams();
    if (Object.keys(exportParams).length) {
        Object.assign(headers, exportParams);
    }
    return {
        action,
        accept,
        showUploadList,
        headers,
        data: { rowId, tableName, attachType, ...data },
        beforeUpload: (file) => {
            message.loading(`${file.name}上传中...`);
        },
        onChange: (info) => {
            if (info.file.status === 'done') {
                let res = info.file.response;
                if (res.code === 0) {
                    message.success(`${info.file.name}文件导入成功`);
                    if(res.data){
                        success && success(info.file.name, res.data);
                         // this.setState({showBillImportModal:true})
                         // this.handleGetBillImportLog(res.data)
                    }
                } else {
                    if(Array.isArray(res.data)){
                        Modal.error({
                            className:'importModal',
                            title: res.message || `${info.file.name}文件导入失败`,
                            content: <div style={{whiteSpace:'pre',maxHeight:'80vh',overflow:'auto'}}>{res.data.join('\n')}</div> ,
                        });
                    }else{
                        message.error(res.message || `${info.file.name}文件导入失败`);
                    }
                }
            } else if (info.file.status === 'error') {
                message.error(`${info.file.name}文件上传失败`);
            }
        },
    }
}

//将查询条件转化成字符串，用于导出
export const transterQuery = (obj) => {
    var arr = [];
    for (var k in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
            if (k === "page") {
            } else if (k === "pagesize") {
            } else if (obj[k] === null) {
            } else {
                arr.push(k + "=" + obj[k])
            }
        }
    }
    return arr.join("&")
}

export const config = configs;



// WEBPACK FOOTER //
// ./src/axios/index.js